An array of `JobCategory` identifiers.

A maximum of 10 job categories may be provided.
